const WhatsAppFloatingButton = () => {
  return (
    <div className="fixed bottom-20 right-4 z-50">
      <a
        href="https://wa.me/918801230123"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
      >
        <img
          src="/img/icons/whatsapp_icon_floating.png"
          alt="WhatsApp"
          className="w-[50px] h-[50px] cursor-pointer"
        />
      </a>
    </div>
  );
};

export default WhatsAppFloatingButton;
